import React, { useCallback } from 'react';
import { useAuth } from '../../hooks/useAuth';
import SupportChat from './SupportChat';
import SupportChatWebSocket from './SupportChatWebSocket';
import { getDomainCfg } from '../../core/state';

interface AuthenticatedSupportChatProps {
  hasProjectContext: boolean;
  resetMessages?: boolean;
}

const AuthenticatedSupportChat: React.FC<AuthenticatedSupportChatProps> = ({ hasProjectContext, resetMessages }) => {
  const { isAuthenticated, authenticate } = useAuth();

  const handleReAuthenticate = useCallback(async () => {
    console.log('Attempting to re-authenticate');
    const success = await authenticate();
    if (success) {
      console.log('Re-authentication successful');
    } else {
      console.log('Re-authentication failed');
    }
    return success;
  }, [authenticate]);

  const USE_WEBSOCKETS = getDomainCfg().chatSettings.useWebsocket;

  

  if (USE_WEBSOCKETS) {
    return (
      <SupportChatWebSocket 
        hasProjectContext={hasProjectContext} 
        resetMessages={resetMessages} 
        isAuthenticated={isAuthenticated}
        onReAuthenticate={handleReAuthenticate}
      />
    );
  } else {
    return (
      <SupportChat 
        hasProjectContext={hasProjectContext} 
        resetMessages={resetMessages} 
      />
    );
  }
};

export default AuthenticatedSupportChat;